import { Component, OnInit } from '@angular/core';
import {Message} from "primeng/primeng";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Tienda} from "./tienda";
import {TiendaService} from "../Services/tienda.service";
import {UsuariosAsignados} from "./usuariosAsignados";
import {UsuarioService} from "../Services/usuario.service";
import {Usuario} from "../usuario/Usuario";
import {Http,Headers, RequestOptions} from "@angular/http";
import {Observable} from "rxjs/Observable";

const URL = 'http://www.turismocomercial.galerasindie.com/cliente/archivo';

@Component({
  selector: 'app-tienda',
  templateUrl: './tienda.component.html',
  styleUrls: ['./tienda.component.css']
})
export class TiendaComponent implements OnInit {

  msgs: Message[] = [];
  formTienda : FormGroup;
  formAsignacion : FormGroup;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnNuevaAsignacion = true;
  btnCancelarAsignacion = false;
  btnGuardarAsignacion = false;
  btnGuardarEditar = false;
  tiposDocumento = [];
  panelRequeridos = false;
  loading = false;
  TiendasRegistrados:Tienda[];
  TiendaSeleccionado:Tienda;
  tipoGuardado = '';
  panelAsignacion = false;
  usuariosRegistradosTienda:UsuariosAsignados[];
  verUsuariosAsignados = false;
  usuariosRegistrados:Usuario[];
  descripcionArchivo = '';
  upArchivo = false;
  role = localStorage.getItem('role');


  constructor(private http:Http,
              private servicioUsuario:UsuarioService,
              private servicioTienda:TiendaService,
              private fb: FormBuilder) { }

  ngOnInit() {
    this.crearControlesTienda();
    this.crearControlesAsignacion();
    this.Cancelar();
    this.poblarTiposDoc();
    this.listarTiendas();
    this.listarUsuarios();
  }

  crearControlesTienda(){
    this.formTienda = this.fb.group({
      nombre:['',Validators.required],
      direccion:['',Validators.required],
      telefono:[''],
      movil:['',Validators.required],
      correo:['',Validators.required],
      web:[''],
      logo:[''],
      regimen:['',Validators.required],
      }
    );

  }
  crearControlesAsignacion(){
    this.formAsignacion = this.fb.group({
        tienda_id:[''],
        usuario_id:[''],
      }
    );

  }
  nuevoTienda(){
    if(this.role == 'Administrador'){
      this.btnNuevo = false;
      this.btnGuardar = true;
      this.btnGuardarEditar = false;
      this.btnCancelar = true;
      this.formTienda.enable();
      this.formTienda.reset();
      this.panelRequeridos = true;
      this.tipoGuardado = 'guardar';
    }else {
      this.mensajes('warn','Atencion','Para la gestion de Tiendas contacte con el Administrador.');
    }
  }
  Cancelar(){
    this.btnGuardar = false;
    this.btnNuevo = true;
    this.btnCancelar = false;
    this.btnGuardarEditar = false;
    this.formTienda.reset();
    this.formTienda.disable();
    this.panelRequeridos = false;
  }
  poblarTiposDoc(){
    this.tiposDocumento.push({label:'Seleccione un Tipo', value:''});
    this.tiposDocumento.push({label:'C.C', value:'C.C'});
    this.tiposDocumento.push({label:'PASAPORTE', value:''});
    this.tiposDocumento.push({label:'C.E.', value:''});
    this.tiposDocumento.push({label:'DNI', value:''});
    this.tiposDocumento.push({label:'NIT', value:''});
    this.tiposDocumento.push({label:'NUIP', value:''});
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  guardarNuevoTienda(){
    if(this.tipoGuardado == 'editar'){
      this.loading = true;
      this.servicioTienda.putTienda(this.formTienda.value,this.TiendaSeleccionado['tienda'].id)
        .subscribe(
          rt => {
            this.mensajes('success','Actualizacion',rt);
            this.listarTiendas();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    else if(this.tipoGuardado == 'guardar') {
      this.loading = true;
      this.servicioTienda.addTienda(this.formTienda.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarTiendas();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    this.tipoGuardado = '';
  }
  listarTiendas(){
    this.loading = true;
    this.servicioTienda.getTienda()
      .subscribe(
        rt => {
          this.TiendasRegistrados = rt;
          console.log(rt);
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  seleccionarTienda(item:Tienda){
    if(this.role == 'Administrador'){
      this.btnNuevo = false;
      this.btnGuardar = false;
      this.btnGuardarEditar = true;
      this.btnCancelar = true;
      this.formTienda.enable();
      this.panelRequeridos = true;
      this.TiendaSeleccionado = item;
      this.TiendaDetalle(item);
      this.tipoGuardado = 'editar';
      this.listarUsuariosByTienda(item);
      this.verUsuariosAsignados = true;
      this.upArchivo = true;
    }else{
      this.mensajes('warn','Atencion','Para la gestion de Tiendas contacte con Administrador.');
    }

  }
  TiendaDetalle(item:Tienda):void {
   this.formTienda.patchValue({
   id:item.id,
     nombre:item.nombre,
     direccion:item.direccion,
     telefono:item.telefono,
     movil:item.movil,
     correo:item.correo,
     web:item.web,
     logo:item.logo,
     regimen:item.regimen,
   });
   }
  guardarNuevaAsignacion(){
    this.loading = true;
    this.formAsignacion.patchValue({
      tienda_id:this.TiendaSeleccionado['tienda'].id,
    });
    console.log(this.formAsignacion.value);
    this.servicioTienda.asignarUsuario(this.formAsignacion.value)
      .subscribe(
        rt => {
          this.mensajes('success','Guardar',rt);
          this.listarUsuariosByTienda(this.TiendaSeleccionado);
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
          this.Cancelar();
        });
  }
  nuevaAsignacion(){
    this.btnNuevaAsignacion = false;
    this.btnGuardarAsignacion = true;
    this.btnCancelarAsignacion = true;
    this.formAsignacion.enable();
    this.formAsignacion.reset();
    this.panelAsignacion = true;
  }
  CancelarAsignacion(){
    this.btnGuardarAsignacion = false;
    this.btnNuevaAsignacion = true;
    this.btnCancelarAsignacion = false;
    this.formAsignacion.reset();
    this.formAsignacion.disable();
    this.panelAsignacion = false;
    this.verUsuariosAsignados = false;
  }
  listarUsuariosByTienda(item:Tienda){
    this.loading = true;
    this.servicioTienda.getUsuariosByTienda(item.id)
      .subscribe(
        rt => {
          this.usuariosRegistradosTienda=rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        });

  }
  listarUsuarios(){
    this.loading = true;
    this.servicioUsuario.getUsuario()
      .subscribe(
        rt => {
          this.usuariosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        });
  }
  subirArchivo(event) {
    let fileList: FileList = event.target.files;
    if(fileList.length > 0) {
      let file: File = fileList[0];
      let formData:FormData = new FormData();
      formData.append('ubicacion',file, file.name);
      formData.append('tienda_id',this.TiendaSeleccionado.id.toString());
      formData.append('descripcion',this.descripcionArchivo);
      let headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });
      this.loading = true;
      this.http.post(`${URL}`, formData, options)
        .map(res => res.json())
        .catch(error => Observable.throw(error))
        .subscribe(
          data => {
            this.mensajes('success','Subir Archivo',data);
            this.loading = false;
            this.upArchivo = false;
          },
          error => this.mensajes('error','Error',error),
        )
    }
  }


}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/tienda/tienda.component.ts